<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="sign-up-container">
  <div class="sign-up-card">
    <h1>{{'signup.title' | translate}}</h1>
    <p class="mt-xl">
      {{'signup.description' | translate}}
    </p>

    <div class="mt-xl">
      <form #form="ngForm" (ngSubmit)="submit()" class="sign-up-form">
        <auth-user-form
          [isNewUser]="true"
          [phoneNumberRequired]="true"
          [showPasswords]="true">
<!--          [userData]="userData">-->
        </auth-user-form>

        <span class="mt-sm text-align-center">
          <p> Vezi <a [routerLink]="['/info/gdpr-terms-and-conditions']" target='_blank' class="mb-xl" data-testid="terms-and-conditions-link">
            {{'signup.terms-and-conditions' | translate}} </a>
          </p>
        </span>

        <button pButton
                type="submit"
                class="p-button-primary pr-xl pl-xl mt-xl mb-md"
                style="width: 75%"
                label="{{'signup.title' | translate}}" data-testid="submit-btn"></button>
      </form>

    </div>
  </div>

  <p-messages [value]="(errorMessages | async) ?? []"></p-messages>

</div>


